export default class MiniFilter {
    main
    items = []
    defaultItem = {
        type: 'select',
        options: {},
        value: '',
        placeholder: 'ALL',
        multi: true,
        class: 'col inputContainer',
        inputClass: '',
        blankIsAll: true,
        // tsSettings: false,
    }
    constructor(options) {
        this.options = {...{
                cols: [
                    {name:'Type', title: 'Type of Email'},
                    {name:'Contractor', title: 'Contractor'},
                ],
                obj: $('<div>').addClass('row'),

            },...options}

        this.defaultItem = {...this.defaultItem, ...options.defaultItem}
        this.main = this.options.obj

    }

    eval(data){
        for(let col of this.options.cols){
            let tmp = {}
            let itm = {...{

                    tsSettings: {
                        options: []
                    }

                }, ...this.defaultItem, ...col}

            let counts = []
            $.each(data, function(index, row) {
                counts[row[col.name]] = (counts[row[col.name]] || 0) + 1

            })

            $(data).each((index, row) => {
                itm.tsSettings.options.push({text: row[col.name], value: row[col.name], count: counts[row[col.name]]})
            })

            // itm.options = [...new Set(itm.options)]
            this.items.push(itm)
        }

        this.render()

    }


    render() {
        $(this.items).each((index, item) => {
            let el = CS.createFromInput(item)
            this.main.append(el)
        })
    }

    get html(){
        return this.main
    }

    get values(){
        return CS.collectData(this.main).inputs
    }
}
